<template>
  <!--
      作者：gan
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <el-form class="demo-form-inline" style="flex-wrap: wrap">
      <el-form-item label="订单名称" label-width="60px">
        <el-input style="width: 200px" size="small" v-model="searchForm.product_name" placeholder="订单名称"></el-input>
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        <el-button size="small" type="primary" @click="addOrder" icon="el-icon-plus">添加订单</el-button>
        <el-button size="small" type="primary" @click="refreshList" icon="el-icon-refresh">刷新</el-button>
        <template v-if="dxlist != ''">
          <el-button @click="godeleteall()" type="danger" size="small" icon="el-icon-delete">删除</el-button>
        </template>
        <template v-else>
          <el-button disabled type="danger" size="small" icon="el-icon-delete">删除
          </el-button>
        </template>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <div>
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" border
        v-loading="loading">
        <el-table-column type="selection" width="40" style="min-width: 100px">
        </el-table-column>
        <el-table-column label="商品" width="400">
          <template slot-scope="scope">
            <div style="display: flex">
              <div style="width: 50px; height: 50px">
                <img :src="scope.row.product.image[0].file_path" alt="" style="width: 100%; height: 100%" />
              </div>
              <div>
                <div>{{ scope.row.product.product_name }}</div>
                <div>{{ scope.row.product_attr }}</div>
                <div>￥{{ scope.row.total_rent }}</div>
                <div>数量：1</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户信息" width="180">
        </el-table-column>
        <el-table-column prop="address" label="租金">
          <template slot-scope="scope">
            <div>已付/总租金</div>
            <div>
              ￥{{ scope.row.deposit ? scope.row.deposit : "0.00" }}/{{
                scope.row.total_rent ? scope.row.total_rent : "0.00"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="押金">
          <template slot-scope="scope">
            商品押金：{{ scope.row.deposit }}
          </template>
        </el-table-column>
        <el-table-column prop="buy_out_price" label="是否买断">
        </el-table-column>
        <el-table-column label="租期">
          <template slot-scope="scope">
            {{ scope.row.lease_time }}
          </template>
        </el-table-column>
        <el-table-column label="订单状态">
          <template slot-scope="scope">
            <div class="czbutton">
              <el-button size="mini" type="primary" @click="editOrder(scope.row)">修改</el-button>
              <el-button size="mini" type="primary" @click="delectOrder(scope.row)">删除</el-button>
              <el-button size="mini" type="primary" @click="shareQRcode(scope.row)">分享二维码</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--表格分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
        layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
    <!-- 弹窗 -->
    <div class="dialogDiv">
      <!-- 添加订单 -->
      <div class="dislogOrder">
        <el-drawer :title="dislogText" :visible.sync="showAddOrderDia" :direction="direction">
          <div class="drawerBox">
            <div class="drawerbox">
              <!-- 选择商品 -->
              <div style="display: flex">
                <el-button type="primary" @click="selectShop">选择商品</el-button>
                <el-button type="primary" v-if="dislogText == '创建订单'" @click="addshop">添加商品</el-button>
              </div>
              <div>
                <div v-if="name">商品名称: {{ name }}</div>
                <div v-if="name && spec_attr">
                  商品规格:
                  <!-- 选择规格 -->
                  <div style="display: flex; flex-direction: column">
                    <div v-for="(item, index) in spec_attr" :key="index" class="item">
                      <div>{{ item.group_name }}:</div>
                      <div style="display: flex">
                        <div v-for="(i, n) in item.spec_items" :key="n">
                          <div v-for="(a, b) in skuarr" :key="b">
                            <div v-if="index == b">
                              <div :class="a == i.item_id ? 'tishi' : 'tishi1'
                                " @click="selectspec(i.item_id, item.group_id, a)">
                                {{ i.spec_value }}
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="zhuText">
                注：首付金额为0时，默认不自定义首期；买断价为0时，账单支付完成自动已完结
              </div>
              <div>
                <el-form :model="form" :rules="rules" size="mini">
                  <el-form-item label="总租金" prop="total_rent">
                    <el-input v-model="form.total_rent" id="total_rent"></el-input>
                  </el-form-item>
                  <el-form-item label="租赁天数" prop="lease_time">
                    <el-input v-model="form.lease_time" id="ceshi"></el-input>
                  </el-form-item>
                  <el-form-item label="首付租金">
                    <el-input v-model="form.first_deposit_price"></el-input>
                  </el-form-item>
                  <el-form-item label="商品押金">
                    <el-input v-model="form.deposit"></el-input>
                  </el-form-item>
                  <el-form-item label="买断总价" prop="buy_out_price">
                    <el-input v-model="form.buy_out_price"></el-input>
                  </el-form-item>
                  <el-form-item label="市场价" prop="market_price">
                    <el-input v-model="form.market_price"></el-input>
                  </el-form-item>
                  <el-form-item label="增值服务">
                    <el-input v-model="form.service_price"></el-input>
                  </el-form-item>
                  <el-form-item label="运费">
                    <el-input v-model="form.freight_price"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div style="text-align: right;">
                <span slot="footer" class="dialog-footer">
                  <el-button @click="showAddOrderDia = false">取 消</el-button>
                  <el-button type="primary" @click="submitCreateOrder">确 定</el-button>
                </span>
              </div>
            </div>
          </div>
        </el-drawer>
      </div>
      <!-- 二维码弹窗 -->
      <el-dialog title="分享二维码" :visible.sync="showShareQRcodeDia" width="30%">
        <div class="qrdiv">
          <img :src="QRCodeUrl" alt="" />
        </div>
      </el-dialog>

      <!-- 选择商品弹窗 -->
      <el-dialog title="选择商品" :visible.sync="selectShopDia" width="40%">
        <div style="display: flex; align-items: center">
          <el-select v-model="shopClassName" @change="changeShopClassName" filterable size="mini">
            <template v-for="cat in shopCalssData">
              <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
              <template v-if="cat.child !== undefined" v-for="two in cat.child">
                <el-option :value="two.category_id" :key="two.category_id" :label="two.name"
                  style="padding-left: 30px"></el-option>
                <template v-if="two.child !== undefined" v-for="three in two.child">
                  <el-option :value="three.category_id" :key="three.category_id" :label="three.name"
                    style="padding-left: 60px"></el-option>
                </template>
              </template>
            </template>
          </el-select>
          <div style="margin-left: 10px">
            <!-- <el-radio v-model="shoptype" label="0">正常商品</el-radio> -->
            <el-radio v-model="shoptype" label="1">快速商品</el-radio>
          </div>
        </div>
        <div style="margin-top: 15px;">
          <el-table :data="shopTableData" style="width: 100%" border>
            <el-table-column prop="product_name" label="商品名称" width="250">
            </el-table-column>
            <el-table-column label="图片">
              <template slot-scope="scope">
                <img :src="scope.row.image[0].file_path" width="30" height="30" />
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="clickShop(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--选择商品分页-->
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" background
              :current-page="curPage1" :page-sizes="[10, 20, 50, 100]" :page-size="10"
              layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber1"></el-pagination>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FastorderApi from "@/api/fastorder.js";
import PorductApi from "@/api/product.js";
export default {
  components: {},
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      drawer: false,
      //快速订单列表
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      //   创建订单弹窗
      showAddOrderDia: false,
      //   搜索词
      product_name: "",
      //   商品列表
      shopOptions: [],
      //   商品ID
      product_id: "",
      name: "",
      spec: "",
      //   规格数据
      spec_attr: [],
      spec_form: [],
      sku: "",
      skuarr: [],
      form: {
        total_rent: "",
        lease_time: "",
        market_price: "",
        buy_out_price: "",
        service_price: "",
        freight_price: "",
        first_deposit_price: "",
        deposit: "",
      },
      rules: {
        total_rent: [
          { required: true, message: "此项必须填写", trigger: "blur" },
        ],
        lease_time: [
          {
            required: true,
            message: "此项必须填写租赁时间是30的倍数",
            trigger: "cahnge",
          },
        ],
        buy_out_price: [
          { required: true, message: "此项必须填写", trigger: "blur" },
        ],
        market_price: [
          { required: true, message: "此项必须填写", trigger: "blur" },
        ],
      },
      // 展示分享二维码
      showShareQRcodeDia: false,
      dislogText: "",
      order_product_id: "",
      QRCodeUrl: "",
      qishu: "",
      // 选择商品弹窗展示
      selectShopDia: false,
      //商品分类名称
      shopClassName: "",
      // 商品分类数据
      shopCalssData: [],
      // 商品数据
      shopTableData: [],
      curPage1: 1,
      pageSize1: 0,
      totalDataNumber1: 0,
      direction: "rtl",
      dxlist: "", //多选删除订单id
      // 商品类型  0 正常 1 快速
      shoptype: "2",
      category_id: "", //分类id
      searchForm: {
        product_name: "",
      },
    };
  },
  created() {
    //   获取数据列表
    this.getTableData();
    let href = window.location.href;
    let url = unescape(href);
    let urlString = url.split("?")[1];
    let obj = {};
    urlString.split("&").forEach((item) => {
      let [key, value] = item.split("=");
      obj[key] = value;
    });
    if (obj.order_product_id) {
      this.addOrder();
      this.product_id = obj.order_product_id;
      this.getShopSpec()
    }
  },
  mounted() { },
  watch: {
    product_id: {
      handler(n, o) {
        if (n) {
          this.getShopSpec();
        }
      },
    },
    shoptype: {
      handler(n, o) {
        if (o !== 2 && n) {
          // 0 正常商品  1 快速商品
          if (n == 1) {
            this.getfastshoplist(this.category_id);
          } else if (n == 0) {
            this.changeShopClassName(this.category_id);
          }
        }
      },
    },
  },
  methods: {
    // 刷新
    refreshList() {
      this.searchForm = {};
      this.getTableData();
      this.$message({
        type: "success",
        message: "刷新订单成功",
      });
    },
    // 获取快速商品
    getfastshoplist() {
      let Params = {};
      Params.page = this.curPage1;
      Params.list_rows = 10;
      Params.category_id = this.category_id;
      FastorderApi.getFastShopList(Params, true)
        .then((res) => {
          // 获取快速商品数据
          this.shopTableData = res.data.list.data;
          this.totalDataNumber1 = res.data.list.total;
          this.shoptype = "1";
        })
        .catch((err) => { });
    },
    // 多选删除
    godeleteall() {
      this.$confirm("是否要删除已选择商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          FastorderApi.deleteallfastshop(
            { order_product_id: this.dxlist },
            true
          ).then(() => {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getTableData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 多选选中
    handleSelectionChange(val) {
      let dxlist = "";
      for (let dxdata of val) {
        dxlist += dxdata.order_product_id + ",";
      }
      this.dxlist = dxlist;
    },
    addshop() {
      let self = this;
      let hash = window.location.hash;
      let link = hash.substring(1);
      let routeData = self.$router.resolve({
        path: "/product/fastproduct/add",
        query: {
          link: link,
        },
      });
      window.open(routeData.href, "_self");
    },
    // 选择商品弹窗展示
    selectShop() {
      this.shoptype = "";
      this.shopClassName = "";
      this.shopTableData = [];
      this.name = "";
      this.form = {};
      this.spec_attr = [];
      this.totalDataNumber1 = 0;
      PorductApi.getBaseData({}, true)
        .then((res) => {
          this.shopCalssData = res.data.category;
        })
        .catch((error) => { });
      this.selectShopDia = true;
    },
    // 获取选择分类下的商品信息
    changeShopClassName(val) {
      this.category_id = val;
      let Params = {};
      Params.page = this.curPage1;
      Params.list_rows = 10;
      Params.category_id = val;
      Params.car_lease = 0;
      if (this.shoptype == 0) {
        PorductApi.getCatShopList(Params, true)
          .then((res) => {
            // 获取正常商品数据
            this.shopTableData = res.data.list.data;
            this.totalDataNumber1 = res.data.list.total;
            this.shoptype = "0";
          })
          .catch((err) => { });
      } else if (this.shoptype == 1) {
        FastorderApi.getFastShopList(Params, true)
          .then((res) => {
            // 获取快速商品数据
            this.shopTableData = res.data.list.data;
            this.totalDataNumber1 = res.data.list.total;
            this.shoptype = "1";
          })
          .catch((err) => { });
      }
    },
    /*选择第几页*/
    handleCurrentChange1(val) {
      let self = this;
      self.curPage1 = val;

      if (self.shoptype == 1) {
        self.getfastshoplist();
      } else if (self.shoptype == 0) {
        self.changeShopClassName();
      }
    },
    /*每页多少条*/
    handleSizeChange1(val) {
      this.curPage1 = 1;
      this.pageSize1 = val;
      if (this.shoptype == 1) {
        this.getfastshoplist();
      } else if (this.shoptype == 0) {
        this.changeShopClassName();
      }
    },
    // 点击商品 跳回原弹窗
    clickShop(row) {
      this.name = row.product_name;
      this.product_id = row.product_id;
      this.selectShopDia = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableData();
    },
    //   获取数据列表
    getTableData() {
      this.loading = true;
      let Params = {};
      Params.search = this.searchForm.product_name;
      Params.page = this.curPage;
      Params.list_rows = this.pageSize;
      FastorderApi.getFastOrder(Params, true).then((res) => {
        this.tableData = res.data.data;
        this.totalDataNumber = res.data.total;
        this.loading = false;
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getTableData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableData();
    },
    // 获取商品规格
    getShopSpec() {
      FastorderApi.getSpec({ product_id: this.product_id }, true).then(
        (res) => {
          this.name = res.data.productName
          let arr = [];
          this.spec_attr = res.data.spec_attr;
          this.spec_form = res.data.spec_list[0].spec_form;
          this.form = this.spec_form;
          this.spec_attr.forEach((item) => {
            item.spec_items.forEach((i, m) => {
              if (m == 0) {
                // 初始规格
                arr.push(i.item_id);
              }
            });
            if (item.group_name == "期数") {
              this.qishu = item.spec_items[0].spec_value;
              let obj = this.spec_form;
              let time = { lease_time: this.qishu * 30 };
              obj = { ...this.spec_form, ...time };
              this.form = obj;
            }
          });
          let arr1 = arr.toString();
          // 商品初始规格
          this.sku = arr1.replaceAll(",", "_");
          this.skuarr = arr
          // 获取文字规格
          this.spec_attr.forEach((item) => {
            item.spec_items.forEach((a) => {
              arr.forEach((b) => {
                if (a.item_id == b) {
                  this.spec += item.group_name + ":" + a.spec_value + " ";
                }
              });
            });
          });
        }
      );
    },
    // 切换规格
    selectspec(val, id, a) {
      this.spec_attr.forEach((item) => {
        if (item.group_id == id) {
          item.spec_items.forEach((i) => {
            if (i.item_id == val) {
              let num = val.toString();
              let a1 = a.toString()
              let b = this.sku.replace(a1, num);
              this.sku = b;
              this.skuarr = this.sku.split('_')
            }
          });
          if (item.group_name == "期数") {
            item.spec_items.forEach((i) => {
              if (i.item_id == val) {
                let num = i.spec_value;
                let obj = this.spec_form;
                let time = { lease_time: num * 30 };
                obj = { ...this.spec_form, ...time };
                this.form = obj;
              }
            });
          }
        }
      });
    },
    //   创建订单
    addOrder() {
      this.product_id = "";
      this.sku = "";
      this.order_product_id = "";
      this.spec_attr = [];
      this.form = {};
      this.dislogText = "创建订单";
      this.showAddOrderDia = true;
    },
    // 提交创建订单
    submitCreateOrder() {
      FastorderApi.getCreateOrder(
        {
          product_id: this.product_id,
          sku: this.sku,
          order_product_id: this.order_product_id,
          total_rent: this.form.total_rent,
          lease_time: this.form.lease_time,
          market_price: this.form.market_price,
          buy_out_price: this.form.buy_out_price,
          service_price: this.form.service_price,
          freight_price: this.form.freight_price,
          first_deposit_price: this.form.first_deposit_price,
          deposit: this.form.deposit,
        },
        true
      ).then((res) => {
        this.getTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
      this.showAddOrderDia = false;
    },
    // 编辑订单
    editOrder(row) {
      this.order_product_id = row.order_product_id;
      this.product_id = row.product_id;
      this.spec = "";
      this.name = row.product.product_name;
      this.form = row;
      // 获取商品的文字规格
      this.sku = row.spec_sku_id;
      FastorderApi.getSpec({ product_id: row.product_id }, true).then((res) => {
        this.spec_attr = res.data.spec_attr;
      });
      this.dislogText = "修改订单";
      this.showAddOrderDia = true;
    },
    // 删除订单
    delectOrder(row) {
      FastorderApi.delFastOrder(
        { order_product_id: row.order_product_id },
        true
      ).then((res) => {
        this.getTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    // 查看二维码
    shareQRcode(row) {
      FastorderApi.getQRcode(
        { order_product_id: row.order_product_id },
        true
      ).then((res) => {
        this.QRCodeUrl = res.data.qrcode;
      });
      this.showShareQRcodeDia = true;
    },
  },
  filters: {},
};
</script>
<style lang="scss" scope>
.drawerBox {
  width: 100%;
  padding: 0 30px 30px;
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
  overflow: auto;
  /* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
  display: none;
}

.czbutton {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

.czbutton .el-button {
  margin-left: 0;
  margin-top: 5px;
}

.el-button {
  margin-left: 0;
}

.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: flex-start;
}

.tishi {
  padding: 0 5px;
  height: 30px;
  line-height: 30px;
  margin: 5px;
  background-color: #ecf5ff;
  border: 1px solid #773ed5;
  color: #773ed5;
  border-radius: 10px;
}

.tishi1 {
  border-radius: 10px;
  padding: 0 5px;
  height: 30px;
  line-height: 30px;
  margin: 5px;
  //   background-color: #ecf5ff;
  border: 1px solid #773ed5;
}

.zhuText {
  font-size: 14px;
  color: red;
  white-space: nowrap;
  margin-top: 5px;
}

.qrdiv {
  display: flex;
  justify-content: center;
}

.caozuoBtn {
  display: flex;
  align-content: center;
  justify-content: center;
  width: 30px;
  height: 10px;
  background-color: #44abf7;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/fastorder.vue